// Import Vue 3 compatible carousel components
import {
  Carousel as Vue3Carousel,
  Slide as Vue3Slide,
  Pagination,
  Navigation,
} from 'vue3-carousel';

// Export Vue 3 compatible carousel components
export const Carousel = Vue3Carousel;
export const Slide = Vue3Slide;
export { Pagination, Navigation };

export default {
  Carousel,
  Slide,
  Pagination,
  Navigation,
};
